import toast from "@/services/Notification";
import HTTP from "@/_helpers/http";
import { MAM__API } from "@/_helpers/urls";
import { MAM__MUTATIONS } from "../mutation-types";
import { MAM__ACTIONS } from "../action-types";
import router from "@/router";

// State
const state = {
  managerLists: [],
  investormanageraccount: null,
  tradingAccountInfo: null,
  accountTypes: [],
  leverages: [],
  allStUserNames: [],
  myManagerAccounts: [],
  myInvestorAccounts: [],
  managerLiveTrades: [],
  investorLiveTrades: [],
  managerInvestorAccounts: [],
  managerInvestorLiveOrders: [],
  managerInvestorOrderHistories: [],
  managerActiveRunningOrdersDetails: {
    totalAccount: 0,
    activeAccounts: 0,
    totalRunningOrders: 0,
    activeMargin: 0,
    activeLot: 0,
    currentProfit: 0,
  },
};

//Getters
const getters = {};

//Mutations
const mutations = {
  [MAM__MUTATIONS.LIVETRADESMANAGERINVESTOR](state, data) {
    state.managerLiveTrades = data.managerLiveTrades;
    state.investorLiveTrades = data.investorLiveTrades;
  },

  [MAM__MUTATIONS.INVESTORMANAGERACCOUNT](state, data) {
    state.investormanageraccount = data;
  },

  [MAM__MUTATIONS.ORDERHISTORYMANAGERINVESTORS](state, data) {
    state.managerInvestorOrderHistories = data;
  },

  [MAM__MUTATIONS.LIVEORDERSMANAGERINVESTORS](state, data) {
    state.managerInvestorLiveOrders = data;
  },

  [MAM__MUTATIONS.MANAGERACCOUNTDETAILS](state, data) {
    state.managerInvestorAccounts = data.investorAccounts;
  },

  [MAM__MUTATIONS.MANAGERLISTS](state, data) {
    state.managerLists = data.managerListJson;
  },

  [MAM__MUTATIONS.TRADINGACCOUNTINFO](state, data) {
    state.tradingAccountInfo = data;
  },

  [MAM__MUTATIONS.ACCOUNTTYPESANDLEVERAGES](state, data) {
    state.accountTypes = data.accountTypes;
    state.leverages = data.leverages;
  },

  [MAM__MUTATIONS.STUSERNAMES](state, data) {
    state.allStUserNames = data.allStUserNames;
  },

  [MAM__MUTATIONS.MYMANAGERACCOUNTS](state, data) {
    state.myManagerAccounts = data;
  },

  [MAM__MUTATIONS.MYINVESTORACCOUNTS](state, data) {
    state.myInvestorAccounts = data;
  },

  [MAM__MUTATIONS.MANAGERACTIVERUNNINGORDERDETAILS](state, data) {
    state.managerActiveRunningOrdersDetails.totalAccount = data.totalAccount;
    state.managerActiveRunningOrdersDetails.activeAccounts =
      data.activeAccounts;
    state.managerActiveRunningOrdersDetails.totalRunningOrders =
      data.totalRunningOrders;
    state.managerActiveRunningOrdersDetails.activeMargin = data.activeMargin;
    state.managerActiveRunningOrdersDetails.activeLot = data.activeLot;
    state.managerActiveRunningOrdersDetails.currentProfit = data.currentProfit;
  },
};
// Actions
const actions = {
  async [MAM__ACTIONS.MANAGERLISTS]({ commit, state }, managerType) {
    try {
      const response = await HTTP({
        trackProgress: true,
        loadingText: 'Processing...'
      }).post(MAM__API.MANAGERLISTS, managerType);
      commit(MAM__MUTATIONS.MANAGERLISTS, response.data);
    } catch (error) {
      console.log(error);
    }
  },

  async [MAM__ACTIONS.INVESTORMANAGERACCOUNT]({ commit, state }, id) {
    try {
      const response = await HTTP({
        trackProgress: true,
        loadingText: 'Processing...'
      }).get(`${MAM__API.INVESTORMANAGERACCOUNT}?id=${id}`);
      commit(MAM__MUTATIONS.INVESTORMANAGERACCOUNT, response.data);
    } catch (error) {
      console.log(error);
    }
  },

  async [MAM__ACTIONS.OPENNEWINVESTORACCOUNT]({ commit, state }, data) {
    try {
      const response = await HTTP({
        trackProgress: true,
        loadingText: 'Processing...'
      }).post(MAM__API.OPENNEWINVESTORACCOUNT, data);
      if (response.status === 200) {
        commit(
          MAM__MUTATIONS.TRADINGACCOUNTINFO,
          response.data.tradingAccountInfo
        );
        router.push("/create-investor-account-success");
      } else {
        toast.error("Something wrong");
      }
    } catch (error) {
      console.log(error);
    }
  },

  async [MAM__ACTIONS.ACCOUNTTYPESANDLEVERAGES]({ commit, state }) {
    try {
      const response = await HTTP({
        trackProgress: true,
        loadingText: 'Processing...'
      }).get(MAM__API.ACCOUNTTYPESANDLEVERAGES);
      commit(MAM__MUTATIONS.ACCOUNTTYPESANDLEVERAGES, response.data);
    } catch (error) {
      console.log(error);
    }
  },

  async [MAM__ACTIONS.STUSERNAMES]({ commit, state }) {
    try {
      const response = await HTTP({
        trackProgress: true,
        loadingText: 'Processing...'
      }).get(MAM__API.STUSERNAMES);
      commit(MAM__MUTATIONS.STUSERNAMES, response.data);
    } catch (error) {
      console.log(error);
    }
  },

  async [MAM__ACTIONS.OPENNEWMANAGERACCOUNT](
    { commit, state, dispatch },
    data
  ) {
    try {
      const response = await HTTP({
        trackProgress: true,
        loadingText: 'Processing...'
      }).post(MAM__API.OPENNEWMANAGERACCOUNT, data);

      if (response.status === 200) {
        dispatch(MAM__ACTIONS.MYMANAGERACCOUNTS);
        toast.success("Manager account created successfully");
        return { success: true }
      }
    } catch (error) {
      console.log(error);
      toast.error(error.response.data.message || "Failed to open account");
    }
  },

  async [MAM__ACTIONS.MYMANAGERACCOUNTS]({ commit, state }) {
    try {
      const response = await HTTP({
        trackProgress: true,
        loadingText: 'Processing...'
      }).get(MAM__API.MYMANAGERACCOUNTS);
      commit(MAM__MUTATIONS.MYMANAGERACCOUNTS, response.data);
    } catch (error) {
      console.log(error);
    }
  },

  async [MAM__ACTIONS.MYINVESTORACCOUNTS]({ commit, state }) {
    try {
      const response = await HTTP({
        trackProgress: true,
        loadingText: 'Processing...'
      }).get(MAM__API.MYINVESTORACCOUNTS);
      commit(MAM__MUTATIONS.MYINVESTORACCOUNTS, response.data);
    } catch (error) {
      console.log(error);
    }
  },

  async [MAM__ACTIONS.LIVETRADESMANAGERINVESTOR]({ commit }, id) {
    try {
      const response = await HTTP({
        trackProgress: true,
        loadingText: 'Processing...'
      }).get(
        MAM__API.LIVETRADESMANAGERINVESTOR + `/${id}`
      );
      commit(MAM__MUTATIONS.LIVETRADESMANAGERINVESTOR, response.data);
    } catch (error) {
      console.error(error);
    }
  },

  async [MAM__ACTIONS.LIVEORDERSMANAGERINVESTORS]({ commit }, id) {
    try {
      const response = await HTTP({
        trackProgress: true,
        loadingText: 'Processing...'
      }).get(
        MAM__API.LIVEORDERSMANAGERINVESTORS + `/${id}`
      );
      commit(MAM__MUTATIONS.LIVEORDERSMANAGERINVESTORS, response.data);
    } catch (error) {
      console.error(error);
    }
  },

  async [MAM__ACTIONS.MANAGERACCOUNTDETAILS]({ commit }, id) {
    try {
      const response = await HTTP({
        trackProgress: true,
        loadingText: 'Processing...'
      }).get(
        MAM__API.MANAGERACCOUNTDETAILS + `/${id}`
      );
      commit(MAM__MUTATIONS.MANAGERACCOUNTDETAILS, response.data);
    } catch (error) {
      console.error(error);
    }
  },

  async [MAM__ACTIONS.MANAGERACTIVERUNNINGORDERDETAILS]({ commit }, id) {
    try {
      const response = await HTTP().get(
        MAM__API.MANAGERACTIVERUNNINGORDERDETAILS + `/${id}`
      );
      commit(
        MAM__MUTATIONS.MANAGERACTIVERUNNINGORDERDETAILS,
        response.data
      );
    } catch (error) {
      console.error(error);
    }
  },

  async [MAM__ACTIONS.UPDATEACTIVESTATUS]({ dispatch }, id) {
    try {
      await HTTP({
        trackProgress: true,
        loadingText: 'Processing...'
      }).post(MAM__API.UPDATEACTIVESTATUS + `/${id}`);
      toast.success("Investor account updated");
    } catch (error) {
      console.error(error);
    }
  },

  async [MAM__ACTIONS.REMOVEINVESTOR]({ dispatch }, id) {
    try {
      await HTTP({
        trackProgress: true,
        loadingText: 'Processing...'
      }).post(MAM__API.REMOVEINVESTOR + `/${id}`);
      toast.success("Investor account removed");
    } catch (error) {
      console.error(error);
    }
  },

  async [MAM__ACTIONS.ORDERHISTORYMANAGERINVESTORS]({ commit }, id) {
    try {
      const response = await HTTP({
        trackProgress: true,
        loadingText: 'Processing...'
      }).get(
        MAM__API.ORDERHISTORYMANAGERINVESTORS + `/${id}`
      );
      // console.log('ORDERHISTORYMANAGERINVESTORS', response.data)
      commit(MAM__MUTATIONS.ORDERHISTORYMANAGERINVESTORS, response.data);
    } catch (error) {
      console.error(error);
    }
  },
};

export default {
  namespaced: true,
  strict: process.env.NODE_ENV !== "production",
  state,
  getters,
  mutations,
  actions,
};
